/* eslint-disable indent */
import React, { useState } from 'react';
import {
  HeaderTextBlock,
  HeaderTextBlockTitle
} from '../../../styles/text-block/header-text-block';
import { ArticleLink } from '../../../styles/article-link';
import { useTopicContext } from '../context';
import {
  SectionWrapper,
  InnerSectionWrapper,
  ArticleWrapper,
  CellWrapper,
  ArticleHeader,
  Article,
  ShowAllButtonWrapper,
  ShowAllButton,
  Caret,
  SmallSeparator
} from './articles.styles';
import { SendInViewEvent } from '../../../helpers/send-in-view-event';

function groupBy(list, keyGetter) {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item) || 'misc';
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}

export const Articles = () => {
  const [showAll, setShowAll] = useState(() => false);
  const { strapiTopic, isLoading, allStrapiArticle, getSupportData: { groupedArticles } = {} } =
    useTopicContext() || {};

  // get all articles that are part of this topic
  const topicArticles =
    allStrapiArticle &&
    allStrapiArticle?.edges?.filter((x) => x.node?.topic?.id === strapiTopic?.id);

  // loop through groupedArticles, and sort the articles inside there
  const groupedArticlesBySubTopic =
    groupedArticles && groupedArticles?.length > 0
      ? groupedArticles?.map((subTopic) => {
          // get get the real articles
          const mappedArticles = subTopic.articles
            ?.map((art) => topicArticles.find((x) => x.node.uid === art))
            .filter(Boolean);

          return [subTopic.subTopicName, mappedArticles];
        })
      : Array.from(groupBy(topicArticles, (x) => x.node?.sub_topic?.sub_topic_name));

  const hasMoreThanThreeGroups = groupedArticlesBySubTopic?.length > 3;
  const [ref] = SendInViewEvent({
    isLoading,
    component_name: 'topic_articles',
    data: { topicArticles, groupedArticlesBySubTopic }
  });

  return (
    <SectionWrapper ref={ref}>
      <HeaderTextBlock>
        <HeaderTextBlockTitle>Articles</HeaderTextBlockTitle>
      </HeaderTextBlock>

      <InnerSectionWrapper>
        <ArticleWrapper>
          {groupedArticlesBySubTopic?.slice(0, 3).map(([key, value]) => {
            return (
              <CellWrapper key={key}>
                <ArticleHeader>{key}</ArticleHeader>

                {value.map(({ node }) => {
                  const { id } = node;

                  return (
                    <Article key={id}>
                      <ArticleLink article={node} />
                    </Article>
                  );
                })}
              </CellWrapper>
            );
          })}
        </ArticleWrapper>

        {hasMoreThanThreeGroups && <SmallSeparator />}

        {showAll && hasMoreThanThreeGroups && (
          <>
            <ArticleWrapper>
              {groupedArticlesBySubTopic?.slice(3, 6).map(([key, value]) => {
                return (
                  <CellWrapper key={key}>
                    <ArticleHeader>{key}</ArticleHeader>

                    {value.map(({ node }) => {
                      const { id } = node;

                      return (
                        <Article key={id}>
                          <ArticleLink article={node} />
                        </Article>
                      );
                    })}
                  </CellWrapper>
                );
              })}
            </ArticleWrapper>

            <SmallSeparator />
          </>
        )}

        {hasMoreThanThreeGroups && (
          <ShowAllButtonWrapper>
            <ShowAllButton onClick={() => setShowAll(!showAll)}>
              Show {showAll ? 'Less' : 'All'} <Caret down={!showAll} />
            </ShowAllButton>
          </ShowAllButtonWrapper>
        )}
      </InnerSectionWrapper>
    </SectionWrapper>
  );
};
